"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCampaignDisplaysDto = exports.CampaignDisplayCandidatesDto = exports.CampaignDisplayCreativeAssignmentDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CampaignDisplayCreativeAssignmentDto {
    displayId;
    creativeId;
    assetId;
}
exports.CampaignDisplayCreativeAssignmentDto = CampaignDisplayCreativeAssignmentDto;
__decorate([
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], CampaignDisplayCreativeAssignmentDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(128),
    __metadata("design:type", String)
], CampaignDisplayCreativeAssignmentDto.prototype, "creativeId", void 0);
__decorate([
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], CampaignDisplayCreativeAssignmentDto.prototype, "assetId", void 0);
class CampaignDisplayCandidatesDto {
    displayIds;
    mediaAssignments;
}
exports.CampaignDisplayCandidatesDto = CampaignDisplayCandidatesDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(100),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsMongoId)({ each: true }),
    __metadata("design:type", Array)
], CampaignDisplayCandidatesDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(400),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CampaignDisplayCreativeAssignmentDto),
    __metadata("design:type", Array)
], CampaignDisplayCandidatesDto.prototype, "mediaAssignments", void 0);
class AddCampaignDisplaysDto extends CampaignDisplayCandidatesDto {
    requestId;
}
exports.AddCampaignDisplaysDto = AddCampaignDisplaysDto;
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], AddCampaignDisplaysDto.prototype, "requestId", void 0);
